import store from 'src/store';
import {
    ModulesApiRoutes,
    ModulesIntents,
    ModulesRoutes,
    ModulesSettings,
} from './index';

const FALLBACK_MODULE = 'gd';

export const getActiveMailerDriver = () => {
    const active = store.getState()?.Modules?.active;
    const key = ModulesApiRoutes[active] ? active : FALLBACK_MODULE;

    return {
        active: key,
        apiRoutes: ModulesApiRoutes[key],
        intents: ModulesIntents[key],
        routes: ModulesRoutes[key],
        settings: ModulesSettings[key],
    };
};
